module.exports = __webpack_public_path__ + "static/gd1-ebe4db441a7ee66855488cc39f4514e8.jpg";